import { createSelector } from 'reselect';
import { getLatestActivityBase } from './getLatestActivityBase';
import { getCurrentLaborTicket } from './getLaborTickets';
import { getPostLaborUpdatesOnNats } from './getPostLaborUpdatesOnNats';

const defaultLatestActivity = {};

const getLatestActivity = createSelector(
  [getLatestActivityBase, getCurrentLaborTicket, getPostLaborUpdatesOnNats],
  (latestActivity, currentLaborTicket, natsFlowEnabled) => {
    // NATS flow: synthesize activity from labor ticket
    if (natsFlowEnabled) {
      if (!currentLaborTicket) {
        return defaultLatestActivity;
      }

      const hasOpenTicket = currentLaborTicket?.state === 'OPEN';
      const endBehavior = currentLaborTicket?.customFields?.endBehavior;
      const isKeptOpen = endBehavior === 'keep-open';

      if (!hasOpenTicket && !isKeptOpen) {
        return defaultLatestActivity;
      }

      // Synthesize activity from labor ticket
      const activityMode =
        currentLaborTicket.type?.toLowerCase() || 'production';
      return {
        activityRef: null, // Not applicable in NATS mode
        activitySetRef: null,
        activityTypeRef: null,
        activityMode,
        start: currentLaborTicket.clockIn,
        end: hasOpenTicket ? null : currentLaborTicket.clockOut,
      };
    }

    return latestActivity;
  }
);

export { getLatestActivity };
